module.exports = __webpack_public_path__ + "img/H01061-02.fa399bea.jpg";